<template>
  <div class="error-404">
    <div class="content">
      <div class="title">
        

        <div style="color: #ff0000;font-size: 20px;line-height: 200px;">
                网站已到期，请尽快联系产品经理进行续费
            </div> 

      </div>
      <!-- <div class="back" @click="getToBack">返回上一页</div> -->
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{}
    },
    methods:{
      getToBack() {
        this.$router.go(-1)
      },
    }
  }
</script>

<style scoped>
.error-404{
  width: 100%;
  height: 100%;
  background-image: url("/static/imgs/pc_404.jpg");
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.error-404 .content {
  width: 560px;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.error-404 .back {
  font-size: 20px;
  color: #FFFFFF;
  background: #80bae8;
  margin-top: 50px;
  padding: 10px 40px;
  border-radius: 30px;
}
.error-404 .title{ font-size: 80px;}
</style>





// WEBPACK FOOTER //
// src/views/home/noauth.vue